import React from 'react';
import {ColumnDef} from "@tanstack/react-table";
import {concepts, Group, Subscription, User} from "fearless-common";
import {getFullName, useTitle} from "fearless-common-ui";
import Pages from "../../components/layout/Pages";
import OrderableTable from "../../components/layout/OrderableTable";
import {adminRoutes} from "../../utils/routes";
import Header from "../../components/Header";
import CellRender from "../../components/layout/table/CellRender";

type SubscriptionWithRelations = Subscription & { user?: User; group?: Group };

const columns: Array<ColumnDef<SubscriptionWithRelations>> = [
    { id: 'id', accessorKey: 'id', header: 'ID', enableSorting: true },
    { id: 'name', accessorKey: 'name', header: `${concepts.Subscription} name`, enableSorting: false },
    {
        id: 'academic_or_commercial', accessorKey: 'academic_or_commercial', header: 'Academic / Commercial',
        cell: ({ row }) => {
            return <>{row?.original?.academic_or_commercial || '-'}</>;
        },
        enableSorting: false
    },
    {
        id: 'individual_or_team', accessorKey: 'user', header: `${concepts.User} / ${concepts.Group}`,
        cell: ({ row }) => {
            const subscription = row.original;
            return <>{subscription?.group ? `${concepts.Group}` : `${concepts.User}`}</>;
        },
        enableSorting: false
    },
    {
      // @ts-ignore
        id: 'subscriber', accessorKey: 'subscriber', header: 'Subscribing entity', cell: ({ row }) => {
            const subscription = row.original;
            return <>{subscription?.group ? `${subscription?.group.name}` : `${getFullName(subscription?.user || null)}`}</>;
        },
      enableSorting: false
    },
    { id: 'status', accessorKey: 'stripe_status', header: 'Status', enableSorting: false },
    { id: 'quantity', accessorKey: 'quantity', header: 'Quantity', enableSorting: true },
    { id: 'created_at', accessorKey: 'created_at', header: 'Sign up at', cell: CellRender.Date, enableSorting: true },
]


export default function AdminSubscriptions() {
  useTitle(`Admin ${concepts.Subscriptions}`);
    return (
        <Pages.Centred padded>
            <Header.Admin>
                {concepts.Subscriptions}
            </Header.Admin>
            <h1>&nbsp;</h1>
            <OrderableTable
                baseEndpoint={'/admin/subscriptions?_with[]=user&_with[]=group&_with[]=items&_orderBy=created_at'}
                memoisedColumns={columns}
                buildLink={(record) => adminRoutes.subscription(record.id)}
                pagination
            />
        </Pages.Centred>
    );
}

